(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return [...(root || document).querySelectorAll(sel)]; }

  function initSort() {
    const select = qs('#cp-sort-by');
    if (!select) return;
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }
function initFilters() {
  const checkboxes = qsa('.cp-sb-checkbox');
  if (!checkboxes.length) return;

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', submitFilters);
  });

  function submitFilters() {
    const url = new URL(window.location.href);

    // remove old filters
    const paramKeys = [...url.searchParams.keys()];

    paramKeys.forEach(function (key) {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    url.searchParams.delete('page');

    checkboxes.forEach(function (cb) {
      if (!cb.checked || cb.disabled) return;

      // PRICE RANGE
      if (cb.classList.contains('cp-price-checkbox')) {
        url.searchParams.set('filter.v.price.gte', cb.value);
        url.searchParams.set('filter.v.price.lte', cb.dataset.max);
      }

      // NORMAL FILTER
      else {
        url.searchParams.append(cb.name, cb.value);
      }
    });

    window.location.assign(url.toString());
  }
}

  function initPriceRange() {
    const priceInputs = qsa('.cp-price-input');
    if (!priceInputs.length) return;
    let timer;
    priceInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(submitPriceRange, 600);
      });
    });
    function submitPriceRange() {
      const url = new URL(window.location.href);
      priceInputs.forEach(function (input) {
        if (input.name) {
          url.searchParams.delete(input.name);
          if (input.value !== '') url.searchParams.set(input.name, input.value);
        }
      });
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  }

  function initAccordion() {
    const headings = qsa('.cp-sb-heading');
    headings.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        const section = this.closest('.cp-sb-section');
        if (!section) return;
        const list = qs('.cp-sb-list', section) || qs('.cp-price-range', section);
        if (list) {
          if (expanded) list.setAttribute('hidden', '');
          else list.removeAttribute('hidden');
        }
      });
    });
  }

  function initMobileSidebar() {
    const btn = qs('.cp-mobile-filter-btn');
    const sidebar = qs('#cp-sidebar');
    if (!btn || !sidebar) return;
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:899;display:none';
    document.body.appendChild(overlay);
    function openDrawer() {
      sidebar.classList.add('is-open');
      overlay.style.display = 'block';
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      sidebar.classList.remove('is-open');
      overlay.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    btn.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function initWishlist() {
    const btns = qsa('.cp-wishlist');
    const saved = JSON.parse(localStorage.getItem('cp_wishlist') || '[]');
    btns.forEach(function (btn) {
      const id = btn.dataset.productId;
      if (saved.includes(id)) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const active = this.classList.toggle('is-active');
        const list = JSON.parse(localStorage.getItem('cp_wishlist') || '[]');
        const idx = list.indexOf(id);
        if (active && idx === -1) list.push(id);
        if (!active && idx > -1) list.splice(idx, 1);
        localStorage.setItem('cp_wishlist', JSON.stringify(list));
        document.dispatchEvent(new CustomEvent('cp:wishlist:change', {
          detail: { productId: id, active: active }
        }));
      });
    });
  }


  function initSwatches() {
    document.querySelectorAll('.cp-swatch').forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        const img = this.dataset.img;
        if (!img || img === '') return;

        const card = this.closest('.cp-card');
        if (!card) return;

        const photo = card.querySelector('.cp-card-photo');
        if (!photo) return;

        photo.style.opacity = '0';
        setTimeout(function () {
          photo.setAttribute('src', img);
          photo.style.opacity = '1';
        }, 150);

        const badge = card.querySelector('.cp-variant-badge');
        if (badge) badge.textContent = swatch.dataset.color;

        card.querySelectorAll('.cp-swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
      });

      // // Reset về ảnh gốc khi mouse rời khỏi swatches
      // swatch.addEventListener('mouseleave', function () {
      //   const card = this.closest('.cp-card');
      //   if (!card) return;
      //   const photo = card.querySelector('.cp-card-photo');
      //   const mainImg = photo && photo.dataset.mainImg;
      //   if (!photo || !mainImg) return;

      //   // Chỉ reset nếu không có swatch nào đang active
      //   const hasActive = card.querySelector('.cp-swatch.is-active');
      //   if (!hasActive) {
      //     photo.style.opacity = '0';
      //     setTimeout(function () {
      //       photo.setAttribute('src', mainImg);
      //       photo.style.opacity = '1';
      //     }, 150);
      //   }
      // });
    });
  }
function initQuickAdd() {
  document.querySelectorAll('.cp-quick-add[data-single-variant="true"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = this.dataset.variantId;
      const btn = this;

      btn.textContent = 'Adding...';
      btn.style.pointerEvents = 'none';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        btn.textContent = '✓ Added';
        setTimeout(function() {
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2v10M2 7h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg> Quick Add';
          btn.style.pointerEvents = '';
        }, 1500);
         setTimeout(function() {
    window.location.reload();
  }, 1000);
      })
      .catch(function() {
        btn.textContent = 'Error';
        btn.style.pointerEvents = '';
      });
    });
  });
}

function initQuickShopFetch() {
  if (typeof $ === 'undefined') return;

  $(document).on('click', '.cp-quick-add[data-fancybox]', function() {
    const srcId = $(this).data('src');
    const $modal = $(srcId);
    const url = $modal.data('url');

    if (!url || $modal.data('loaded')) return;

    $modal.html('<div style="padding:2rem;text-align:center;min-width:320px;min-height:100px;color:#888">Loading...</div>');

    $.get(url + '?section_id=product-quickshop', function(html) {
      const $html = $(html);
      const $content = $html.find('.product-quickshop__container').first();

      if ($content.length) {
        $modal.html($content);
      } else {
        $modal.html($html.find('[data-section-type="product-quickshop"]').first().html() || '<div style="padding:2rem;text-align:center"><a href="' + url + '">View Product →</a></div>');
      }

      $modal.data('loaded', true);

      // Chỉ update Fancybox layout, không trigger section events
      const instance = $.fancybox.getInstance();
      if (instance) instance.update();

    }).fail(function() {
      $modal.html('<div style="padding:2rem;text-align:center"><a href="' + url + '" style="color:#111;font-size:14px">View Product →</a></div>');
      $modal.data('loaded', true);
    });
  });
}
  document.addEventListener('DOMContentLoaded', function () {
    initSort();
    initFilters();
    initPriceRange();
    initAccordion();
    initMobileSidebar();
    initWishlist();
    initSwatches();
    initQuickAdd();
    document.querySelectorAll('.modal[id^="fancybox-product-"]').forEach(function(modal) {
    document.body.appendChild(modal);
  });

  if (typeof $ !== 'undefined') {
    if (typeof $.fn.fancybox !== 'undefined') {
      $('[data-fancybox]').fancybox();
    }
    initQuickShopFetch();
  }
  });

})();